import { render, staticRenderFns } from "./agreementAdd.vue?vue&type=template&id=55e67458&scoped=true"
import script from "./agreementAdd.vue?vue&type=script&lang=js"
export * from "./agreementAdd.vue?vue&type=script&lang=js"
import style0 from "./agreementAdd.vue?vue&type=style&index=0&id=55e67458&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e67458",
  null
  
)

export default component.exports